import React from "react";
import { Grid } from "react-bootstrap";
export var Container = function (_a) {
    var children = _a.children, _b = _a.fluid, fluid = _b === void 0 ? false : _b, className = _a.className;
    return (React.createElement(Grid, { fluid: fluid, className: className }, children));
};
